import React from 'react'
import { useAppSelector } from '../../../../slices/store'
import { getWebSocket } from '../../../../socket/socket';
import { Button } from '../../../../ui/Button/Button';
import { IoCheckmark } from 'react-icons/io5';
import { CopyLink } from '../../CopyLink/CopyLink';
import { StyledLobby } from './styles';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

export const Lobby = () => {
  const {allUsers, isAdmin, nickname} = useAppSelector(s => s.mainStore);
  const ws = getWebSocket();

  const { t } = useTranslation();
  const translationPrefix = 'music_mafia.lobby';

  const handleStartGame = () => {
    ws?.send('{"type": "start_new_game"}');
  }

  return (
    <StyledLobby>
      <div className='subtitle'>
        {t(`${translationPrefix}.copy`)}
      </div>
      <div className='link-section'>
        <CopyLink className={clsx("link", {"link-with-btn": isAdmin})} />
        {isAdmin && <Button className="button" width={200} title={t(`${translationPrefix}.start_game`)} handleClick={handleStartGame} />}
      </div>
      <div className='users-list-wrapper'>
        <div className='list-title'>
          {t(`${translationPrefix}.users_in_room`)}:
        </div>
        <div className='users-list'>
          {allUsers.map((user, i) => <div key={user+i}>{user}{i === allUsers.length - 1 ? '' : ' / '}</div>)}
        </div>
      </div>
    </StyledLobby>
  )
}
